/*
 * FAQs accordion
 *   - max-height-based slide-toggle (same pattern as Room Detail accordions)
 *   - Single-open per column: opening one item in a column closes the others
 *     in that column. Cross-column items don't affect each other.
 */

function initOne(root) {
    if (root.dataset.wired === '1') return;
    root.dataset.wired = '1';

    const cols = Array.from(root.querySelectorAll('.js-faqs-col'));
    if (!cols.length) return;

    const panelOf = (toggle) => {
        const id = toggle.getAttribute('aria-controls');
        return id ? document.getElementById(id) : null;
    };

    const close = (toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
        const panel = panelOf(toggle);
        if (!panel) return;
        // Snap to the rendered height before transitioning to 0 so the
        // animation starts from the actual current size.
        panel.style.maxHeight = panel.scrollHeight + 'px';
        // eslint-disable-next-line no-unused-expressions
        panel.offsetHeight;
        panel.style.maxHeight = '0px';
    };

    const open = (toggle) => {
        toggle.setAttribute('aria-expanded', 'true');
        const panel = panelOf(toggle);
        if (!panel) return;
        panel.style.maxHeight = panel.scrollHeight + 'px';
    };

    cols.forEach((col) => {
        const toggles = Array.from(col.querySelectorAll('.js-faqs-toggle'));
        const closeOthersInCol = (except) => {
            toggles.forEach((t) => {
                if (t === except) return;
                if (t.getAttribute('aria-expanded') === 'true') close(t);
            });
        };

        toggles.forEach((toggle) => {
            const panel = panelOf(toggle);
            if (panel) {
                panel.addEventListener('transitionend', (e) => {
                    if (e.propertyName !== 'max-height') return;
                    if (toggle.getAttribute('aria-expanded') === 'true') {
                        // Allow the panel to grow if its content reflows later.
                        panel.style.maxHeight = 'none';
                    }
                });
            }
            toggle.addEventListener('click', () => {
                const isOpen = toggle.getAttribute('aria-expanded') === 'true';
                if (isOpen) {
                    close(toggle);
                } else {
                    closeOthersInCol(toggle);
                    open(toggle);
                }
            });
        });
    });
}

export function initFaqs() {
    document.querySelectorAll('.js-faqs').forEach(initOne);
}
